var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"has-text-left container"},[_c('CentralItemsContainer',{attrs:{"hint":""}},_vm._l((_vm.arrayPlayers),function(player){return _c('PlayerItem',{key:player.id,attrs:{"player":player},on:{"click":_vm.onPlayerItemClicked}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }